"use strict";

require("../../style/index.css");

require("./index.css");

require("../../input/style/css");

require("../../time-picker/style/css");

require("../../tag/style/css");